import { Box, Card, CardContent, Divider, Grid, Step } from "@mui/material";
import { useBudgetFormContext } from "../../../context/BudgetFormContext";
import Steps from "../../steps/Steps";
import ActualSelectionForm from "./ActualSelectionForm";
import FormActions from "./FormActions";
import FormEmail from "./FormEmail";
import FormHeader from "./FormHeader";
import FormList from "./FormList";
import FormSelection from "./FormSelection";

const BudgetGrid = () => {
  const { data } = useBudgetFormContext();
  return (
    <Card>
      <CardContent container={true} spacing={3}>
        <FormHeader />
      </CardContent>
      {data.dates.length > 0 && (
        <>
          <Divider />
          <CardContent container={true} spacing={3}>
            <FormList />
          </CardContent>
          <Divider />
          <CardContent container={true} spacing={3}>
            <FormSelection />
          </CardContent>
        </>
      )}
    </Card>
  );
};
const BudgetForm = () => {
  return (
    <>
      <Grid container={true} spacing={2} columns={12}>
        <Grid item size={9.5}>
          <Box sx={{ height: "80vh" }} overflow={"auto"}>
            <Steps>
              <Step>
                <BudgetGrid />
              </Step>
              <Step>
                <FormEmail />
              </Step>
            </Steps>
          </Box>
        </Grid>
        <Grid item size={2.5}>
          <ActualSelectionForm />
          <FormActions />
        </Grid>
      </Grid>
    </>
  );
};

export default BudgetForm;
